module.exports = __webpack_public_path__ + "img/bgd6.e94df996.svg";